import { Box, Button, Typography } from "@material-ui/core";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MaskAndValid from "utils/maskAndValid";

export default function Footer({
  totals,
  clearOrder,
  openCartModal,
  openOrdersModal,
  theme,
}) {
  return (
    <Box className="footer-container">
      <Box className="footer-content">
        <Box className="footer-left">
          <Box className="footer-stat">
            <Typography className="footer-stat-label">Itens</Typography>
            <Typography className="footer-stat-value">
              {totals.qty} <span className="footer-stat-unit">un</span>
            </Typography>
          </Box>
          <Box className="footer-divider" />
          <Box className="footer-stat">
            <Typography className="footer-stat-label">Total</Typography>
            <Typography 
              className="footer-stat-total"
              style={{ color: theme.primary }}
            >
              R$ {MaskAndValid.maskPrice(totals.val)}
            </Typography>
          </Box>
        </Box>
        <Box className="footer-right">
          {openOrdersModal && (
            <Button
              className="orders-btn"
              onClick={openOrdersModal}
              startIcon={<ReceiptLongIcon />}
            >
              Meus Pedidos
            </Button>
          )}
          <Button className="clear-btn" onClick={clearOrder}>
            Limpar
          </Button>
          <Button
            className="submit-btn"
            onClick={openCartModal}
            style={{ backgroundColor: theme.primary }}
            startIcon={<CheckCircleIcon />}
          >
            FECHAR PEDIDO
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
